/** User-facing classification for unified additional record summaries and detail keys. */
export enum UnifiedAdditionalRecordClassificationType {
  UNSPECIFIED = 'Unspecified',
  ALLERGIES = 'Allergies',
  FAMILY_HISTORY = 'Family history',
  SOCIAL_HISTORY = 'Social history',
  VACCINATIONS = 'Vaccinations',
  ADDITIONAL_REFERENCE_DOCUMENTS = 'Additional reference documents',
  PROVIDERS = 'Providers',
}
